import { useState } from 'react';
import { Box, Typography} from '@mui/material';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ImageViewer from './ImageViewer';

interface Attachment {
  id: string;
  medicalCertificateId: string;
  attachment: string;
}
interface AnexosGridProps {
  attachments: Attachment[];
}

const getFilename = (attachment: Attachment) => {
  const url = attachment.attachment;
  const fileName = url.split('/')[url.split('/').length - 1];
  return fileName.substring(33, 999);
};

const isImage = (filename: string) => {
  return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(filename);
};

const isPdf = (filename: string) => {
  return /\.pdf$/i.test(filename);
};

const AnexosGrid = ({ attachments }: AnexosGridProps) => {
  const [hoveredIdx, setHoveredIdx] = useState(-1);
  
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0.75 }}>
        {attachments.map((attachment, index) => {
          const filename = getFilename(attachment);
          const fileIsImage = isImage(filename);
          const isHovered = hoveredIdx === index;

          return (
            <ImageViewer
              key={attachment.id}
              medicalCertificateId={attachment.medicalCertificateId}
              imageUrl={attachment.attachment}
              alt="Documento anexo"
              tooltipTitle={filename}
              renderTrigger={(onClick) => (
                <Box
                  onClick={isPdf(filename) ? () => window.open(attachment.attachment, '_blank') : onClick}
                  onMouseEnter={() => setHoveredIdx(index)}
                  onMouseLeave={() => setHoveredIdx(-1)}
                  sx={{
                    borderRadius: 1.5,
                    overflow: 'hidden',
                    bgcolor: 'rgba(255,255,255,0.03)',
                    border: 1,
                    borderColor: isHovered
                      ? 'rgba(255,255,255,0.12)'
                      : 'rgba(255,255,255,0.05)',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    '&:hover': {
                      borderColor: 'rgba(255,255,255,0.12)',
                    },
                  }}
                >
                  {/* Box Miniatura */}
                  <Box
                    sx={{
                      height: 106,
                      background: fileIsImage
                        ? 'linear-gradient(135deg, #111827, #1e2a4a)'
                        : 'linear-gradient(135deg, #1c1008, #2a1a0a)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                    }}
                  >
                    {fileIsImage ? (
                        <img src={attachment.attachment} alt={filename} style={{ fontSize: 24, color: '#3b82f6', opacity: 0.3 }}></img>
                    ) : (
                      <InsertDriveFileOutlinedIcon sx={{ fontSize: 24, color: '#d97706', opacity: 0.3 }} />
                    )}

                    <Box
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        bgcolor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.5,
                        opacity: isHovered ? 1 : 0,
                        transition: 'opacity 0.15s',
                      }}
                    >
                      <VisibilityIcon sx={{ fontSize: 14, color: '#ddd' }} />
                      <Typography sx={{ fontSize: 10, color: '#ddd' }}>
                        Visualizar
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ px: 1, py: 0.75, backgroundColor: '#ffffff'}}>
                    <Typography
                      noWrap
                      sx={{ fontSize: 10.5, color: 'black', fontWeight: 600 }}
                    >
                      {filename}
                    </Typography>
                  </Box>
                </Box>
              )}
            />
          );
        })}
      </Box>
  );
};

export default AnexosGrid;
